import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';
import sortBy from 'lodash/sortBy';

const CONTEXT = 'licenseRenewal';

export const fetchLicenseRenewal = async (retailerId, threshold) => {
  const { url } = DepsService.rest.widgets.licenseRenewal;
  const queryParams = {};
  const urlParams = { retailerId };

  const retailers = await DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);

  const recalculated = retailers.map((retailer) => ({
    ...retailer,
    percentExpirationDays: appHelpers.calculateDaysLeftToPercentages(retailer.expirationDays, threshold),
  }));

  return sortBy(recalculated, ['expirationDays', 'retailerNumber']);
};

export const fetchLicenseRenewalFormLink = async (retailerId) => {
  const { url } = DepsService.rest.widgets.licenseRenewalForm;
  const queryParams = {};
  const urlParams = { retailerId };

  return await DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/license-renewal.api.js